export default class DroneService {

    constructor(resource) {
        this._resource = resource('block/drones');
    }

    blocks() {
        return this._resource
            .query()
            .then( res =>  {
                return res.json();
            }, err => {
                throw new Error('Não foi possível obter a lista de publicacoes.');
            });
    }
}



// WEBPACK FOOTER //
// ./src/domain/DroneService.js